<template>
  <div class="anzahl">
    <Header />
    <Hero step="anzahl" />
    <Anzahl />
    <Footer />
    <SlideNavigation
      prev-route="bestaetigung"
      next-route="/"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import Anzahl from '@/components/Anzahl.vue'
import Footer from '@/components/Footer.vue'
import SlideNavigation from '@/components/SlideNavigation.vue'

export default {
  name: 'AnzahlView',
  components: {
    Header,
    Hero,
    Anzahl,
    Footer,
    SlideNavigation
  },
  data() {
    return {}
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>
